import React, { memo } from "react";
import DOMPurify from "dompurify";

const SafeHTML = ({ html }) => {
  if (typeof html !== "string") {
    console.error("SafeHTML: Expected `html` to be a string");
    return null;
  }

  const cleanHTML = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [
      "a",
      "p",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "div",
      "ul",
      "ol",
      "li",
      "strong",
      "em",
      "img",
    ],
    ALLOWED_ATTR: [
      "href",
      "target",
      "rel",
      "className",
      "style",
      "src",
      "alt",
      "aria-label",
    ],
    ADD_ATTR: ["target", "rel"],
    ADD_URI_SAFE_ATTR: ["target", "rel"],
    ALLOWED_URI_REGEXP: /^(https?|ftp|mailto|tel):|^#/i,
    FORCE_ATTR: {
      a: {
        target: "_blank",
        rel: "noopener noreferrer",
      },
    },
  });

  return (
    <div
      className="safe-html-content"
      dangerouslySetInnerHTML={{ __html: cleanHTML }}
    />
  );
};

export default memo(SafeHTML);
